'use client';

import { Typography } from '@musinsa/mds';
import Image from 'next/image';
import { twMerge } from 'tailwind-merge';
import type { BankSelectItemProps } from './types';

export const BankSelectItem = ({ bank, isSelected, onSelect, className }: BankSelectItemProps) => {
  const onClick = () => {
    onSelect(bank.displayName);
  };

  if (!bank) return null;

  return (
    <div
      onClick={onClick}
      className={twMerge(
        'w-full px-4 pb-3 cursor-pointer text-left flex items-center gap-2 pt-3',
        className,
      )}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick();
        }
      }}
    >
      <Image
        src={bank.imageUrl}
        alt={bank.displayName}
        width={20}
        height={20}
        className="rounded"
      />
      <Typography
        colorScheme={isSelected ? 'black' : 'gray-600'}
        variant={isSelected ? 'body13pxMed' : 'body13pxReg'}
      >
        {bank.displayName}
      </Typography>
    </div>
  );
};
